import * as xss from 'xss'

const basicAttributes = ['href', 'target', 'id']
const ariaAttributes = ['aria-label', 'aria-describedby']

const xssOptions = {
  whiteList: {
    a: [...ariaAttributes, ...basicAttributes],
    ul: [...ariaAttributes],
    ol: [...ariaAttributes],
    li: [...ariaAttributes],
    p: [...ariaAttributes],
    div: [...ariaAttributes, ...basicAttributes],
    br: [],
    b: [...ariaAttributes],
    strong: [...ariaAttributes],
    em: [...ariaAttributes],
    h1: [...ariaAttributes],
    h2: [...ariaAttributes],
    h3: [...ariaAttributes],
    h4: [...ariaAttributes],
    span: [...ariaAttributes, ...basicAttributes],
    small: [...ariaAttributes, ...basicAttributes],
  },
}

const xssParser = new xss.FilterXSS(xssOptions)

/**
 * Strips out most html tags, but allows very basic html to be used.
 */
export const stripTagsAllowBasicHtml = (str: string): string => {
  return xssParser.process(str)
}
